<template>
    <section>
        <el-row :gutter="20">
            <el-col :span="18" :offset="2">
                <el-col :span="8" :offset="8" style="padding-block-end:30px">
                    <span style="font-size: 22px; font-weight: bold">产品信息操作</span>
                </el-col>
                <el-form :model="editForm" label-width="100px" :rules="editFormRules" ref="editForm" label-position="left">
                     <el-col :span="24">
                        <el-form-item label="产品主分类" prop="TypeId">
                            <el-cascader style="width: 100%" v-model="editForm.TypeId" :options="TypeList" :props="{
                                expandTrigger: 'hover',
                                children: 'Children',
                                label: 'Title',
                                value: 'Id',
                            }" @change="edithandleChange">
                            </el-cascader>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="动态分类" prop="ListInTypeTwo">
                            <el-checkbox-group 
                                v-model="editForm.ListInTypeTwo">
                                <el-checkbox v-for="typeTwo in TypeListInTypeTwo" :label="typeTwo.Id" :key="typeTwo.Id">{{typeTwo.Title}}</el-checkbox>
                            </el-checkbox-group>
                            <el-tag type="info" v-if="!TypeListInTypeTwo" >暂无动态分类</el-tag>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="产品头图" prop="FirstPng">
                            <ImageFile :value="firtimgList" :imgLimit="1" @change="firtImageChange"></ImageFile>
                        </el-form-item>
                    </el-col>
                      <el-col :span="8">
                        <el-form-item label="产品状态" prop="Status">
                            <el-radio-group v-model="editForm.Status">
                                <el-radio :label="0">启用</el-radio>
                                <el-radio :label="1">停用</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="产品排序" prop="Sort">
                            <el-input v-model="editForm.Sort" type="number" auto-complete="off"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="品牌标识" prop="BrandType">
                            <selectPBBrand style="width: 100%" v-model="editForm.BrandType">
                            </selectPBBrand>
                        </el-form-item>
                    </el-col>
                    <el-col :span="21">
                        <el-form-item label="产品名称" prop="Title">
                            <el-input v-model="editForm.Title" type="Text" auto-complete="off"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="3">
                        <el-form-item label-width="0px">
                            <el-button type="primary" @click="query()">产品货号选择</el-button>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label-width="0px">
                         <template>
                            <el-table size="small" :data="MatnrInfolist" border>
                                <el-table-column
                                    prop="Title"
                                    label="物料名称"
                                    header-align="center"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="TivCode"
                                    label="货号编码"
                                    header-align="center"
                                    align="center">
                                </el-table-column>
                                 <el-table-column
                                    prop="Matnr"
                                    label="物料编码"
                                    header-align="center"
                                    align="center">
                                </el-table-column>
                                 <el-table-column
                                    prop="Matkl"
                                    label="物料组"
                                    header-align="center"
                                    align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="MSTAEString"
                                    label="物料状态"
                                    header-align="center"
                                    align="center">
                                </el-table-column>
                                <el-table-column label="操作" fixed="right" header-align="center"
                                 align="center" width="100">
                                    <template slot-scope="scope">
                                      <el-button type="text" size="small" @click="delData(scope.row)"> 删除 </el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </template>
                    </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="产品内容" prop="Content">
                            <MyEditor myQuillEditor="myQuillEditor" :value="editForm.Content" @change="EditorChange">
                            </MyEditor>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" :offset="8" style="padding-block-end:30px">
                        <el-button @click="rout">取消</el-button>
                        <el-button type="primary" @click.native="addSubmit()" :loading="addLoading">提交</el-button>
                    </el-col>
                </el-form>
            </el-col>
        </el-row>

        <el-dialog title="数据选择" :visible.sync="editFormVisible" v-model="editFormVisible" :close-on-click-modal="false">
            <sapMatnrList @change="sapMatnrChange"></sapMatnrList>
        </el-dialog>
    </section>
</template>

<script>
import { GetTypeListchildrenAsync,getHomeManageProductInId,PostProductManage,GetTypeListInTypeTwo } from '../../../api/api';
  import sapMatnrList from "./SapMatnrList.vue";
    export default {
    components: {
        sapMatnrList,
    },
        data() {
            return {
                editForm:{
                    Id: 0,
                    TypeId:0,
                    Title:null,
                    TivCode: null,
                    Matnr:null,
                    FirstPng: null,
                    FirstPngUrl:null,
                    Content:null,
                    QRcode:null,
                    Status:true,
                    Sort:0,
                    ListInTypeTwo:[],
                    Matkl:null
                },
                MatnrInfolist:[],  //物料详情信息
                maxIndex:0,  //物料详情数据行
                editFormRules: {
                    TypeId:[{ required: true, message: "请选择产品分类", trigger: "blur" }],
                    Title: [{ required: true, message: "请输入产品名称", trigger: "blur" }],
                    Content: [{ required: true, message: "富文本内容不能为空", trigger: "blur" }],
                    BrandType:[{ required: true, message: "品牌标识必选", trigger: "blur" }]

                },
                firtimgList:[],

                //所有二级分类
                TypeList:[],
                TypeListInTypeTwo:[],  //动态类型

                IsAdd:true, //是否

                addLoading:false,
                editFormVisible:false,
                Id:''

            }
        },
        methods: {

            delData(index, row) {
                this.MatnrInfolist.splice(index, 1);
            },
            //查询所有二级分类
            GetTypeList()
            {
                //主要分类
                let para={
                    typeClass : 1
                };
                GetTypeListchildrenAsync(para).then((res)=>{
                    if(res.data.success)
                    {
                        this.TypeList = res.data.response
                    }
                })
            },
            firtImageChange(val)
            {
                this.firtimgList = val;
                if (val.length == 0) {
                    this.$set(this.editForm,'FirstPng',null);
                }   
            },
            edithandleChange(val)
            {
                this.editForm.TypeId = val[val.length - 1];
            },
            EditorChange(val)
            {
                 this.editForm.Content = val;
            },
            addSubmit() {
                console.log(this.editForm);
                this.$refs.editForm.validate((valid) => {
                    if (valid) {
                        this.$confirm("确认提交吗？", "提示", {}).then(() => {
                            if(!this.MatnrInfolist || this.MatnrInfolist.length==0)
                            {
                                  this.$message({
                                        message: "请选择货号信息",
                                        type: "warning",
                                    });
                                  return;
                            }
                            this.addLoading = true;
                            let para = Object.assign({}, this.editForm);
                            para.MatnrInfolist = this.MatnrInfolist;
                            console.log(para);
                            const formData = new FormData();
                            if (this.firtimgList) {
                                let imgFil = this.firtimgList.filter((s) => s.status == "ready");
                                if (imgFil != null) {
                                    imgFil.forEach((it, index) => {
                                        formData.append("formFirtImgs", it.raw);
                                    });
                                }
                            }
                            formData.append("model", JSON.stringify(para));
                            PostProductManage(formData).then((res) => {
                                this.addLoading = false;
                                if (res.data.success) {
                                    this.$message({
                                        message: res.data.msg,
                                        type: "success",
                                    });
                                    this.editFormVisible = false;
                                    this.rout();
                                } else {
                                    this.$message({
                                        message: res.data.msg,
                                        type: "error",
                                    });
                                }
                            })
                        });

                    } else { return false; }

                })
            },
            //取消
            rout()
            {
                 this.$router.push({
                    path: "/ManagePB/Product/pageList",
                });
            },
            //选择产品
            query()
            {
                this.editFormVisible = true;
            },
            sapMatnrChange(val)
            {
                let mater = val;
                 if(mater && mater.length>0)
                 {
                    mater.forEach((it, index) => {
                        this.MatnrInfolist.push({Title:it.MAKTX, 
                            TivCode:it.BISMT, Matnr: it.MATNR,Matkl:it.MATKL,MSTAE:it.MSTAE,
                             MSTAEString: it.MSTAEString,ZQJBS:it.ZQJBS,ZJSRQ: it.ZJSRQ,ZKSRQ:it.ZKSRQ})
                    });
                 }
                this.editFormVisible = false;
            },
            queryInId() {
                if (this.Id) {
                    let para = {
                        id: this.Id
                    };
                    getHomeManageProductInId(para).then((res) => {
                        if (res.data.success) {
                            let row = res.data.response;
                            this.firtimgList = row.FirstPngUrl ? [{ url: row.FirstPngUrl }] : [];
                            this.editForm = res.data.response;
                            this.MatnrInfolist =  this.editForm.MatnrInfolist;
                        }
                    })
                }
            },
            //查询动态分类
            GetTypeListInTypeTwo()
            {
                let para ={
                    typeClass:2
                };
                GetTypeListInTypeTwo(para)
                .then((res)=>{
                    if(res.data.success)
                    {
                        console.log(res.data.response);
                        this.TypeListInTypeTwo = res.data.response
                    }
                })
            }
        },
        mounted() {
            this.GetTypeList();
            this.GetTypeListInTypeTwo();
            let Id = this.$route.query.Id;
            console.log(this.dis);
            if (typeof Id != "undefined") {
                this.Id = Id;
                 setTimeout(() => {
                    this.queryInId();
                }, 1000); // 3000 毫秒 = 3 秒
                
            }
        }
    }

</script>